import { render, staticRenderFns } from "./live-after-buy.vue?vue&type=template&id=36524582&scoped=true&"
import script from "./live-after-buy.vue?vue&type=script&lang=ts&"
export * from "./live-after-buy.vue?vue&type=script&lang=ts&"
import style0 from "./live-after-buy.vue?vue&type=style&index=0&id=36524582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36524582",
  null
  
)

export default component.exports